import React, { Component } from 'react'
import Link from 'gatsby-link'

class Header extends Component {
  render() {
    return (
      <div
        style={{
          background: 'transparent',
          height: '10vh',
        }}
      >
        <div
          style={{
            margin: '0 auto',
            maxWidth: 960,
            padding: '1.45rem 1.0875rem',
          }}
        >
          <h1 style={{ margin: 0 }}>
            <Link
              to="/"
              style={{
                color: 'transparent',
                textDecoration: 'none',
              }}
            >
              gigantoid
            </Link>
          </h1>
        </div>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js